<template>
  <div>
    <div>

       <div class="layout-breadcrumb">
        <Breadcrumb>
          <Breadcrumb-item href="#" >
            <span style="color:#fff;">系统管理</span>
          </Breadcrumb-item>
          <Breadcrumb-item href="#">
          <span style="color:#fff;">SQL监控</span>
          </Breadcrumb-item>
        </Breadcrumb>
      </div>

      <div class="layout-content">

         
         <div style="padding:50px 20px;"> 
           嵌入sql页面
         </div>

      </div>


    </div>

  </div>
</template>
<style scoped lang="scss">
  .table-wrapper {
    overflow: scroll;
  }

  .method-wrapper {
    float: left;
    margin-bottom: 10px;
  }

  .clearfix:after {
    content: ".";
    display: block;
    height: 0;
    visibility: hidden;
    clear: both;
  }
  .mRight{
    margin-right:10px;
  }
  .mLeft{
    margin-left:10px;
  }
</style>
<script>
  import api from '../../api/apinew'
  import axios from 'axios'
  import Qs from 'qs'
  export default{
    data(){
      return {
        key:'',
        pagerData:{  
           data:[],  
           page:{  
              //分页数  
               // arrPageSize:[10,20,30,40],  
               //分页大小  
               pagesize:10,  
               //总分页数  
               pageCount:1,  
               //当前页面  
               pageCurrent:1,  
               //总数  
               totalCount:0  
           }  

        },
        listdata:[],
        columns7: [
            {
                type: 'selection',
                width: 60,
                align: 'center'
            },
            {   
                title: 'ID',
                type: 'index',
                width: 60,
                align: 'center'
            },
            {
                title: '用户名',
                key: 'username',
                align: 'center'
            },
            {
                title: '邮箱',
                key: 'email',
                align: 'center'
            },
            {
                title: '电话',
                key: 'phone',
                align: 'center'
            },
            {
                title: '状态',
                key: 'state',
                align: 'center'
            },
            {
                title: '创建时间',
                key: 'creatTime',
                align: 'center'
            },
            {
                title: '操作',
                key: 'action',
                width: 150,
                align: 'center',
                render: (h, params) => {
                    return h('div', [
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small'
                            },
                            style: {
                                marginRight: '5px'
                            },
                            on: {
                                click: () => {
                                    this.show(params.index)
                                }
                            }
                        }, '修改'),
                        h('Button', {
                            props: {
                                type: 'error',
                                size: 'small'
                            },
                            on: {
                                click: () => {
                                    this.remove(params.index)
                                }
                            }
                        }, '删除')
                    ]);
                }
            }
        ],
        // lists: this.mockTable(),
        createnodemodel: false,
        nodetypes: [],
        selnodeType: '',
        nodeNumber: 1,
        editNodeModel: false,
        selNodetoEdit: {},
        formValidate: {
            name: '',
            mail: '',
            phone:'',
            date: '',
            time: '',
            state: ''
        },
        ruleValidate: {
            name: [
                { required: true, message: '用户名不能为空', trigger: 'blur' }
            ],
            mail: [
                { required: true, message: '邮箱不能为空', trigger: 'blur' },
                { type: 'email', message: '邮箱格式不正确', trigger: 'blur' }
            ],
            phone: [
                { required: true, message: '电话不能为空', trigger: 'blur' },
                { type: 'number', message: '电话格式不正确', trigger: 'blur' }
            ],
            state: [
                { required: true, message: '状态不能为空', trigger: 'change' }
            ],
            date: [
                { required: true, type: 'date', message: '请选择日期', trigger: 'change' }
            ],
            time: [
                { required: true, type: 'string', message: '请选择时间', trigger: 'change' }
            ]
      }
      
      }
    },
    mounted:function(){  
        // this.getLists();
        // api.getUser.getLists({'page':1,'limit':10}, resp => {
        //   this.admingateway.number = resp.info.toString();
        //   this.admingateway.name = '管理员列表';
        // }, error => {
          
        // })
            // axios.get('http://115.29.214.141:8093/web/sys/user/list',{
            //   'page':1,
            //   'limit':10
            // }, {
            //   headers: {
            //     "Content-Type": "application/json;charset=UTF-8" ,
            //     "Accept": "application/json"
            //   }, 
            //   transformRequest: [
            //     function (data) {
            //       return Qs.stringify(data);
            //     }],
            // }).then(
            //   (resp) => {
            //     console.log(resp.data)
            //     console.log(resp.data.code)
            //     // var totalNum = 0;  
            //     // for(var i = 0; i < lists.length; i++){  
            //     //     //console.log("res.data[i] is " + i + "\n " + JSON.stringify(res.data[i]));  
            //     //     var object = eval(lists[i]);  
            //     //     object.index = i+1;  
            //     //     totalNum ++;  
            //     //     // console.log("i is " + i + "\n " + JSON.stringify(object)); 
            //     //     // console.log(this.listdata) 
            //     //     this.listdata.push(object);  
            //     //     if(i<10){   //初始化获取数据的过程中，将前10个默认加入分页data  
            //     //         this.pagerData.data.push(object);  
            //     //     }  
            //     // }  
            //     // this.pagerData.page.totalCount = totalNum;  

            //   //   if (resp.data.code == 200) {
            //   //     sessionStorage.setItem('smartkitusername', resp.data.result.username);
            //   //     sessionStorage.setItem('accesstoken', resp.data.result.token);
            //   //      // 正确跳转页面
            //   //     console.log('200');
            //   //     this.$router.push({ name: 'Index' })
                 
                 
            //   //   this.$router.replace({ name: 'home' })
            //   // } else { 
            //   //   this.$Message.error('登录失败' + resp.data.code)
            //   // }
            // });
     
        
        // var   lists = [
        //             {
        //                 username: '张三',
        //                 email:'111@qq.com',
        //                 phone:'15200001111',
        //                 state: '正常',
        //                 creatTime: '2018-1-29'
        //             },
        //             {
        //                 username: '李四',
        //                 email:'222@qq.com',
        //                 phone:'15200001111',
        //                 state: '正常',
        //                 creatTime: '2018-11-29'
        //             },
        //             {
        //                 username: '王二麻子',
        //                 email:'331@qq.com',
        //                 phone:'15200008888',
        //                 state: '正常',
        //                 creatTime: '2018-08-29'
        //             },
        //             {
        //                 username: '张三',
        //                 email:'111@qq.com',
        //                 phone:'15200001111',
        //                 state: '正常',
        //                 creatTime: '2018-1-29'
        //             },
        //             {
        //                 username: '李四',
        //                 email:'222@qq.com',
        //                 phone:'15200001111',
        //                 state: '正常',
        //                 creatTime: '2018-11-29'
        //             },
        //             {
        //                 username: '王二麻子',
        //                 email:'331@qq.com',
        //                 phone:'15200008888',
        //                 state: '正常',
        //                 creatTime: '2018-08-29'
        //             },
        //             {
        //                 username: '张三',
        //                 email:'111@qq.com',
        //                 phone:'15200001111',
        //                 state: '正常',
        //                 creatTime: '2018-1-29'
        //             },
        //             {
        //                 username: '李四',
        //                 email:'222@qq.com',
        //                 phone:'15200001111',
        //                 state: '正常',
        //                 creatTime: '2018-11-29'
        //             },
        //             {
        //                 username: '王二麻子',
        //                 email:'331@qq.com',
        //                 phone:'15200008888',
        //                 state: '正常',
        //                 creatTime: '2018-08-29'
        //             },
        //             {
        //                 username: '张三',
        //                 email:'111@qq.com',
        //                 phone:'15200001111',
        //                 state: '正常',
        //                 creatTime: '2018-1-29'
        //             },
        //             {
        //                 username: '李四',
        //                 email:'222@qq.com',
        //                 phone:'15200001111',
        //                 state: '正常',
        //                 creatTime: '2018-11-29'
        //             },
        //             {
        //                 username: '王二麻子',
        //                 email:'331@qq.com',
        //                 phone:'15200008888',
        //                 state: '正常',
        //                 creatTime: '2018-08-29'
        //             },
        //             {
        //                 username: '张三',
        //                 email:'111@qq.com',
        //                 phone:'15200001111',
        //                 state: '正常',
        //                 creatTime: '2018-1-29'
        //             },
        //             {
        //                 username: '李四',
        //                 email:'222@qq.com',
        //                 phone:'15200001111',
        //                 state: '正常',
        //                 creatTime: '2018-11-29'
        //             },
        //             {
        //                 username: '王二麻子',
        //                 email:'331@qq.com',
        //                 phone:'15200008888',
        //                 state: '正常',
        //                 creatTime: '2018-08-29'
        //             },
        //             {
        //                 username: '李四',
        //                 email:'222@qq.com',
        //                 phone:'15200001111',
        //                 state: '正常',
        //                 creatTime: '2018-11-29'
        //             },
        //             {
        //                 username: '王二麻子',
        //                 email:'331@qq.com',
        //                 phone:'15200008888',
        //                 state: '正常',
        //                 creatTime: '2018-08-29'
        //             }
        //          ];
     
        this.loading = false;  
    },
    methods: {
       
    },

    components: {}
    }
</script>



// WEBPACK FOOTER //
// sql.vue?2a97c766